export default __webpack_public_path__ + "static/media/march.50560b85.jpg";